<p-card *ngIf="hasBillingInformation" class="w-full p-2 m-4 md:w-6/12">
  <ng-template #title>Billing Information</ng-template>

  <ul class="p-0 m-0 list-none border-top-1 surface-border">
    <li class="flex flex-wrap px-2 py-3 align-items-center surface-ground">
      <div class="w-4/12 font-medium md:w-2/12 text-primary-300">
        Latest Invoice
      </div>
      <div class="w-8/12 md:w-10/12 md:flex-order-0 flex-order-1 text-400">
        {{ latestInvoiceDate | date }}
      </div>
    </li>
    <li class="flex flex-wrap px-2 py-3 align-items-center surface-ground">
      <div class="w-4/12 font-semibold text-primary-300 md:w-2/12">
        Current Balance
      </div>
      <div class="w-8/12 text-400 md:w-10/12">
        {{ this.customerBalance | currency : "USD" }}
      </div>
    </li>
    <li class="flex flex-wrap px-2 py-3 align-items-center surface-ground">
      <div class="w-4/12 font-semibold text-primary-300 md:w-2/12">
        Monthly Price
      </div>
      <div class="w-8/12 text-400 md:w-10/12">
        {{ this.subscriptionTotal | currency : "USD" }}
      </div>
    </li>
    <li class="flex flex-wrap px-2 py-3 align-items-center surface-ground">
      <div class="w-4/12 font-semibold text-primary-300 md:w-2/12">
        Auto Payment Enabled
      </div>
      <div class="w-8/12 text-400 md:w-10/12">
        {{ customer_overview()?.autopay_status! | boolToText }}
      </div>
    </li>
  </ul>
  <ng-template #footer>
    <div class="w-full p-4 mt-4 font-semibold text-primary-300">
      <p-button
        label="Make Payment"
        pRipple
        icon="pi pi-wallet"
        class="p-4 rounded-md bg-primary-500"
        (onClick)="makePayment()" />
    </div>
  </ng-template>
</p-card>
